import { CSSProperties } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { CircleAlert, Target } from 'lucide-react';

const DROPDOWN_STYLE: CSSProperties = {
  flex: '1 1 0',
  minWidth: 0,
  height: 44,
  alignItems: 'center',
  border: '2px solid #F1F0EE',
  borderRadius: 12,
};

// Shown when the dashboard filter isn't narrowed to a single class: the focus controls stay
// visible but inert so the layout matches the focused state, and the banner says how to enable them.
export const UnitFocusNoClassState = (): JSX.Element => (
  <div className="tw-flex tw-w-full tw-flex-col tw-gap-4">
    <div className="tw-flex tw-w-full tw-items-start tw-gap-4">
      <Dropdown
        value={null}
        options={[]}
        placeholder="Select a unit..."
        disabled
        style={DROPDOWN_STYLE}
        aria-label="Select a unit"
        className="tw-bg-neutral-50"
      />
      <button
        type="button"
        disabled
        className="tw-inline-flex tw-w-72 tw-shrink-0 tw-cursor-not-allowed tw-items-center tw-justify-center tw-gap-3 tw-whitespace-nowrap tw-rounded-full tw-border-2 tw-border-solid tw-border-neutral-100 tw-bg-neutral-200 tw-px-6 tw-py-3 tw-text-base tw-font-bold tw-leading-5 tw-text-neutral-600"
      >
        <Target size={20} aria-hidden />
        Set focus
      </button>
    </div>
    <div
      className="tw-flex tw-w-fit tw-items-center tw-gap-2 tw-rounded-xl tw-border-2 tw-border-solid tw-border-amber-200 tw-bg-amber-50 tw-px-3 tw-py-2"
      data-testid="no-class-focus-banner"
    >
      <span className="tw-inline-flex tw-shrink-0 tw-text-amber-500">
        <CircleAlert size={16} aria-hidden className="tw-text-amber-800" />
      </span>
      <span className="tw-text-base tw-leading-5 tw-text-amber-800 tw-font-atkinson">
        <span className="tw-font-bold">Switch your filter to a Class</span> to set focus on a Unit
      </span>
    </div>
  </div>
);
